(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("react-hook-thunk-reducer", ["React"], factory);
	else if(typeof exports === 'object')
		exports["react-hook-thunk-reducer"] = factory(require("react"));
	else
		root["react-hook-thunk-reducer"] = factory(root["React"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_react__) {
return 